/* English dictionary: game namespace. See src/i18n/README.md. */

import type { TextSpec } from '../text';

const game = {
  'game.cardCount': [ { type: 'param', name: 'n' }, ' cards' ],
  'game.tracker.title': [ 'Tracker' ],
  'game.tracker.titlePick': [ 'Tracker · click a header to pick from the discard' ],
  'game.tracker.row.status': [ 'Status' ],
  'game.tracker.row.located': [ 'Deck — located' ],
  'game.tracker.row.region': [ 'Deck — half-tracked (inferred)' ],
  'game.tracker.row.untracked': [ 'Deck — untracked (inferred)' ],
  'game.tracker.row.otherHand': [ { type: 'param', name: 'name' }, "'s hand (inferred)" ],
  'game.tracker.cellExact': [ 'Exact value ', { type: 'param', name: 'value' } ],
  'game.tracker.hintHover': [ 'Hover a card header or a number in the table for details' ],
  'game.tracker.hintTouch': [ 'Tap a card header or a number in the table for details' ],
  'game.steal.hint': [ "Draw one card from an opponent" ],
  'game.settlement.noWinner': [ 'No winner' ],
  'game.settlement.winner': [ { type: 'param', name: 'name' }, ' wins' ],
  'game.settlement.alive': [ 'Alive' ],
  'game.settlement.eliminated': [ 'Out' ],
  'game.settlement.row': [ { type: 'param', name: 'status' }, '   ', { type: 'param', name: 'name' }, '   Hand ', { type: 'param', name: 'n' } ],
  'game.chooseName': [ 'Choose a card name' ],
  'game.give.unnamed': [ 'Opponent requests a card' ],
  'game.give.named': [ 'Opponent requests [', { type: 'param', name: 'name' }, ']' ],
  'game.menu.title': [ 'Menu' ],
  'game.menu.saveAndExit': [ 'Save and quit' ],
  'game.menu.leave': [ 'Leave game' ],
  'game.menu.sync': [ 'Refresh sync' ],
  'game.menu.syncing': [ 'Syncing…' ],
  'game.menu.synced': [ 'Synced' ],
  'game.menu.syncFailed': [ 'Sync failed' ],
  'game.online.syncFailed': [ '[s3] manual sync failed:' ],
  'game.online.stalePick': [ '[s3] draw pick missed: no pending draw choice' ],
  'game.online.sendFailed': [ '[s3] action send failed:' ],
  'game.online.sendFailedReason': [ 'Send failed (network error)' ],
  'game.online.rejected': [ '[s3] host rejected the action, rolled back:' ],
  'game.online.reasonPrefix': [ 'reason:' ],
  'game.online.protocolError': [ '[s3] game protocol error:' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
game satisfies Record<string, TextSpec>;
export default game;
